import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid } from "@material-ui/core";
import "./dialog-delete-domain.css";
import LabelModalPure from "../labelModalPure/labelModalPure";
import ButtonHLPure from "../buttonHL/buttonHL.pure";

/* === Custom component title for dialog === */
const CustomDeleteSignatureTitleBar = (props) => {
  const { t } = useTranslation();
  return (
    <div className="dialogDeleteDomain-title">
      <span>{t("dialogDeleteDomain.titleDeleteDomain")}</span>
    </div>
  );
};

const DialogDeleteDomainPure = (props) => {
  const { t } = useTranslation();
  const labelMessageDeleteStyles = {
    marginLeft: "4px",
    textAlign: "center",
  };

  return (
    <Dialog title={<CustomDeleteSignatureTitleBar />} onClose={props.remove}>
      {/* <form> */}
      <div className="k-form">
        <div className="dialogDeleteDomain-label-container">
          <LabelModalPure label={`${t("dialogDeleteDomain.AreYouShureToDelete")} ${props.userInRemove.name}?`}/> 
        </div>
        <div  className="dialogDeleteDomain-btns-delete-container">
          <ButtonHLPure 
            nameBtn={t("button.cancel")}
            primary={false}
            onClickBtn={props.remove}
          />
          <ButtonHLPure 
            nameBtn={t("button.accept")}
            primary={true}
            onClickBtn={props.deleteDomain}
          />
        </div>
      </div>
      {/* </form> */}
    </Dialog>
  );
};

export { DialogDeleteDomainPure as default };
